export enum WorkingStatuses {
  PermanentEmployee = 'permanent_employee',
  TemporaryEmployee = 'temporary_employee',
  SelfEmployed = 'self_employed',
  Retired = 'retired',
  Internship = 'internship',
  Freelance = 'freelance',
  Unemployed = 'unemployed',
}
